import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

export const Message = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.brand.darkGreen
}));

export const FieldWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '100%',
  padding: '4px 0'
});

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.lead
}));

export const FieldInput = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  '& .MuiInputBase-input': {
    paddingRight: '32px'
  },
  '& .MuiFormHelperText-root': {
    ...theme.typography.body2B,
    lineHeight: 1.2,
    letterSpacing: theme.typography.body2R.letterSpacing,
    marginTop: '4px'
  }
}));

export const ErrorIcon = styled(Box)({
  position: 'absolute',
  top: '4px',
  right: 0,
  display: 'flex',
  pointerEvents: 'none'
});

export const Actions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  width: '100%'
});

export const RequestCodeButton = styled(LoadingButton)(({ theme }) => ({
  ...theme.typography.body7B,
  height: '50px',
  gap: '8px',
  padding: '12px 16px 14px 24px',
  '&.Mui-disabled': {
    color: alpha(theme.palette.brand.darkGreen as string, 0.4)
  }
}));

export const ContinueButton = styled(Button)(({ theme }) => ({
  ...theme.typography.body7B,
  paddingTop: 0
}));
